export const SECCOMP_BACKEND_BASE_PATH = '/seccomp';
export const SECCOMP_BACKEND_COMPLIANCES_PATH = '/compliance-dashboard';
export const SECCOMP_PLUGIN_ID = 'seccomp';
